export default {
  'externel-bucket-info-title': 'Externel bucket info',
  'externel-bucket-input-title': 'Externel bucket input',
  'externel-bucket-confirm-title': 'External bucket linkage confirmation',
  'label-bucket-name': 'Bucket name',
  'externel-bucket-confirm-message': 'Is it okay to perform linked processing with the bucket information below?',
}
